// extracted by mini-css-extract-plugin
export default {"button":"Massage_button__xJTs+"};